export class SiteListBase
{
	constructor()
	{
	}
}